import { PayloadAction } from "@reduxjs/toolkit";
import { GroupsState } from "../../models/GroupsState";
import { UpdateGroupPayload } from "../../payload/UpdateGroup/UpdateGroupPayload";

const updateGroupFetch = (state: GroupsState, action: PayloadAction<UpdateGroupPayload>) => {
    state.isLoading = true;
}

export default updateGroupFetch;